import { Box } from '@mui/material'
import React from 'react'
import { useWatch } from 'react-hook-form'
import { useInstallationForm } from 'src/Libs/flow/installation/hooks'
import { InstallationFormOverview } from '../../components'
import { ScrollRestore } from '../../../components/ScrollRestore'
import { HideDirtyStateProvider } from '../../providers'
import { ElectricalGridSettings } from '../components/ElectricalGridSettings'
import EmcAndSmartMeterGateway from '../components/EmcAndSmartMeterGateway'
import { Location } from '../components/Location'
import { ModbusTcpServer } from '../components/ModbusTcpServer'
import { BannerLocations, BannerQueue } from 'src/Libs/banners'
import { SettingsRedirectHintCard } from 'src/Elements/Data'
import { useParams } from 'react-router-dom'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useIsTariffRedirectDisabled } from 'src/Libs/system-settings/hooks/use-is-tariff-redirect-disabled'

export const Overview: React.FC = () => {
  const { control } = useInstallationForm()
  const isNewInstallation = useWatch({ control, name: 'id' }) === null
  const { installationId, storageId } = useParams<{ installationId: string; storageId: string }>()
  const { t } = useCustomTranslation()
  const isTariffRedirectDisabled = useIsTariffRedirectDisabled()

  return (
    <>
      <HideDirtyStateProvider hideDirtyState={isNewInstallation}>
        <BannerQueue location={BannerLocations.FlowSettingsAdvancedSettingsOverview} sx={{ mt: [2, 0], mb: [0, 2] }} />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pb: [2, 0], mb: [8, 0] }}>
          <InstallationFormOverview />

          <EmcAndSmartMeterGateway />

          <Location />

          <ElectricalGridSettings />

          <SettingsRedirectHintCard
            title={t('installation.configOverview.tariff')}
            boxTitle={t('installation.configOverview.tariff.redirect.title')}
            buttonText={t('systemSettings.price-based-charging.tariffs.redirect.button-text')}
            redirectUrl={`/installation/${installationId}/${storageId}/properties/tariffs`}
            isRedirectDisabled={isTariffRedirectDisabled}
            disabledTooltip={isTariffRedirectDisabled ? t('common.disabled-because-of-offline-system') : undefined}
          />

          <ModbusTcpServer />
        </Box>
      </HideDirtyStateProvider>

      <ScrollRestore />
    </>
  )
}
